module.exports = [{"id":"nl-NL","name":"Nederlands","language":"nl","region":"NL","isDefault":true},{"id":"en-US","name":"English","language":"en","region":"US","isDefault":false}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/translations/_.json
// module id = 206
// module chunks = 14